<template>
  <div class="wrap">
    <div class="img_box">
      <img src="@/assets/img/header_icon.png"
           alt="">
    </div>
    <div class="btns">
      <div class="login"
           v-if="!$store.state.isLogin"
           @click="toLogin">注册/登录</div>
      <div v-else>您好，ID{{$store.state.loginCode}}</div>
      <div class="order"
           @click="toReleas">发布信息</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  created () {
    const code = sessionStorage.getItem('usercode');
    if (code) {
      this.$store.commit('login');
    }

  },
  methods: {
    toLogin () {
      this.$router.push({ name: 'login' });

    },
    toReleas () {
      this.$router.push({ name: 'releaseInfo' });
    }
  },
}
</script>

<style scoped>
.wrap {
  width: 1120px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 15px;
  margin-top: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.img_box {
  width: 166px;
  height: 42px;
}
.img_box img {
  width: 100%;
}
.btns {
  display: flex;
  align-items: center;
}
.login {
  width: 72px;
  height: 30px;
  background: #ffe6e5;
  border-radius: 2px;
  font-size: 14px;
  color: #e53631;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.order {
  width: 72px;
  height: 30px;
  background: #e53631;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  line-height: 30px;
  text-align: center;
  margin-left: 6px;
  cursor: pointer;
}
</style>